import { TrendsSubjectColorResolver } from './trends-subject-color-resolver';
import { Injectable } from '@angular/core';
import { chain, isEmpty } from 'lodash';
import { LabTestResult } from '../lab-test-results';
import { ChartLegendItem } from '../legend';
import { getShapeByGender, getFlaggedClassName } from './chart-helper';
import { SubjectTitleRenderer } from '../renderer/subject-title-renderer';

@Injectable()
export class OsrLegendDataService {

    constructor(private colorResolver: TrendsSubjectColorResolver) { }

    public buildSexLegendData(currentTestData: LabTestResult[]): ChartLegendItem[] {
        const legend = chain(currentTestData)
            .uniqBy(r => r.sex)
            .map(r =>
                ({
                    shape: getShapeByGender(r.sex),
                    color: '#fff',
                    stroke: 'black',
                    label: r.sex || 'unknown',
                    key: null
                }))
            .orderBy(l => l.label)
            .value();
        return legend;
    }

    public buildSubjectLegendData(currentTestData: LabTestResult[]): ChartLegendItem[] {
        const legend = chain(currentTestData)
            .uniqBy(r => r.ctSubjectId)
            .map(r =>
                ({
                    shape: 'line',
                    color: this.getLineColor([r]),
                    label: SubjectTitleRenderer.renderTitle({
                        data: r
                    }),
                    key: r.ctSubjectId
                } as ChartLegendItem))
            .orderBy(l => l.label)
            .value();

        return legend;
    }

    public buildFlaggedLegendData(currentTestData: LabTestResult[]): ChartLegendItem[] {
        const legend = chain(currentTestData)
            .map(r => getFlaggedClassName(r))
            .uniq()
            .sort()
            .map(flaggedClassName =>
                ({
                    shape: 'square',
                    class: flaggedClassName,
                    label: flaggedClassName,
                    key: null
                } as ChartLegendItem))
            .value();

        return legend;
    }

    private getLineColor(results: LabTestResult[]) {

        if (isEmpty(results)) {
            return '';
        }

        const index = results[0].subjectSerialNumber;
        return this.colorResolver.getColor(index);
    }
}
